import React from "react";
// import iconAndroid from "../../assets/images/home/android.webp";
// import iconApple from "../../assets/images/home/apple.webp";
// import iconAppleW from "../../assets/images/home/apple-w.webp";
// import iconDiscord from "../../assets/images/home/discord.webp";
// import iconWechat from "../../assets/images/home/wechat.webp";
// import DownItem from "./DownItem/DownItem";
// import DownItemMobile from "./DownItemMobile/DownItem";
// import Button from "../../Components/Button/Button";
// import Carousel from "../../Components/Carousel/Carousel";
// import img_qrGooglePlay from "../../assets/images/qrGooglePlay.png";
// import img_qrChinaAndroid from "../../assets/images/qrChinaAndroid.png";
// import img_qriOS from "../../assets/images/qriOS.png";
// import img_qrDiscord from "../../assets/images/qrDiscord.png";
// import AvatarSlider from "../../Components/AvatarSlider/index";
import "./home.css";
import "./homeMedium.css";

import Hero from "./Hero/Hero";
import Features from "./Features/Features";
import HowItWorks from "./HowItWorks/HowItWorks";
import CreateCharacter from "./CreateCharacter/CreateCharacter";
import LearningSystem from "./LearningSystem/LearningSystem";
import Testimonials from "./Testimonials/Testimonials";
import FinalCTA from "./FinalCTA/FinalCTA";

function Main() {

  return (
    <div className="main-container">
      <Hero />
      <Features />
      <HowItWorks />
      <CreateCharacter />
      <LearningSystem />
      <Testimonials />
      <FinalCTA />
    </div>
  );
}

export default Main;
